import { useEffect, useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import { CircularProgress } from "@mui/material";
import api from "../api/api";
import BackButton from "../components/BackButton";
import Pagination from "../components/Pagination";
import { useNavigate } from "react-router-dom";

 
const WarehouseRequestsOwner = () => {
  const [activeTab, setActiveTab] = useState("pending");
  const [pendingData, setPendingData] = useState([]);
  const [acceptedData, setAcceptedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
 
  const navigate = useNavigate();
 
  const fetchData = async () => {
    setLoading(true);
    setError("");
 
    try {
      const [pendingResponse, acceptedResponse] = await Promise.all([
        api.get("/wh-owner/pending-requests"),
        api.get("/wh-owner/accepted-requests"),
      ]);
 
      setPendingData(pendingResponse.data.requests || []);
      setAcceptedData(acceptedResponse.data.requests || []);
    } catch (err) {
      console.error(err);
      setError("Something went wrong while fetching data.");
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchData();
  }, []);
  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
      .format(date)
      .replace(/,/g, ""); // removes the comma
  }
 
  // Determine active dataset based on selected tab
  const activeData = activeTab === "pending" ? pendingData : acceptedData;
 
  // Pagination Logic
  const totalPages = Math.ceil(activeData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = activeData.slice(startIndex, startIndex + itemsPerPage);
 
  const goToPage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };
 
  const handleItemsPerPageChange = (num) => {
    setItemsPerPage(num);
    setCurrentPage(1);
  };
 
  // Reset page on tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };
 
  const Table = ({ data }) => (
    <div className="position-relative">
      <div
        className={`table-responsive table-fixed-header overflow-auto ${
          itemsPerPage >= 20 ? "mb-80" : itemsPerPage > 11 ? "mb-3" : ""
        }`}
      >
        <table
          className={`table table-bordered table-hover ${
            itemsPerPage >= 20 ? "mb-3" : itemsPerPage < 11 ? "mb-0" : ""
          }`}
        >
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Product Name</th>
              <th>Storage Type</th>
              <th>Warehouse</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Action</th>
            </tr>
          </thead>
 
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.customer_name}</td>
                  <td>{item.product_name}</td>
                  <td>{item.storage_type}</td>
                  <td>{item.warehouse_name}</td>
                  <td>{formatDate(item.start_date)}</td>
                  <td>{formatDate(item.end_date)}</td>
                  <td>
                    <SendIcon
                      style={{ cursor: "pointer", color: "#8393a2" }}
                      onClick={() =>
                        navigate(
                          `/view-wh-request/${item.warehouse_request_id}/${item.warehouse_id}`
                        )
                      }
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
 
  return (
    <>
      <BackButton />
 
      <div className="row mb-3">
        <div className="col-6">
          <button
            className={` ${
              activeTab === "pending" ? "activeTab" : "deactivetab"
            }`}
            onClick={() => handleTabChange("pending")}
          >
            Pending Requests
          </button>
        </div>
        <div className="col-6">
          <button
            className={` ${
              activeTab === "accepted" ? "activeTab" : "deactivetab"
            }`}
            onClick={() => handleTabChange("accepted")}
          >
            Accepted Requests
          </button>
        </div>
      </div>
 
      {loading && (
        <div className="text-center">
          <CircularProgress />
          <p>Loading...</p>
        </div>
      )}
 
      {error && <p className="text-danger text-center">{error}</p>}
 
      {!loading && !error && <Table data={currentItems} />}
 
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </>
  );
};
 
export default WarehouseRequestsOwner;